export { TableOfContents } from './lib/TableOfContents'
export type { TableOfContentsProps, TocEntry } from './lib/TableOfContents'
